export default __webpack_public_path__ + "static/media/saw.2652f6a2.png";